const EmptyRouterView = () => /* webpackChunkName: "EmptyRouterView" */ import("./../views/administrative_aps/EmptyRouterView.vue");
const AdministrativeAps = () => /* webpackChunkName: "Home" */ import("./../views/administrative_aps/Home.vue");
const PatientManager = () => /* webpackChunkName: "PatientHome" */ import("./../views/some_hcm/patient/PatientHome.vue");

export const routes = [
  {
    path: "/administrative-aps",
    component: EmptyRouterView,
    children: [
      {
        path: "",
        name: "administrativeApsHome",
        component: AdministrativeAps,
      },
      {
        path: "gestion-paciente",
        name: "administrativeAPSsomeHcmPatientManager",
        component: PatientManager,
      },
    ],
  },
];
